function Users() {
  return <div>USERS</div>;
}

export default Users;
